import React from "react"
import CitizenAndOthers from "./CitizenandOther"
import PrivateProfessionals from "./PrivateProfessionals"
import { useLocation } from 'react-router-dom';


const ApplyOnline = () => {
    const location = useLocation();
    const flag = location?.state?.params || 'professional';
    return (
        <React.Fragment>
        <div style={{display: 'flex', justifyContent: 'center'}}>
            {flag === 'citizen' && <CitizenAndOthers />}
            {flag === 'professional' && <PrivateProfessionals />}
        </div>
        </React.Fragment>
    )
}

export default ApplyOnline